// STYLES
import './_navbar.scss'

// LIBS
import React from 'react'

// INTERFACE
class HeaderNavbar extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      display: {
        'curriculum': 'none',
        'prospective-students': 'none',
        'courses': 'none',
        'partnerships': 'none'
      }
    }
  }

  handleClick(event) {
    event.stopPropagation()
    let state = this.state
    let target = event.target.dataset.target
    this._closeDropdowns(target)
    state.display[target] = state.display[target] === 'block' ? 'none' : 'block'
    this.setState(state)
  }

  _closeDropdowns(keep) {
    let state = this.state
    Object.keys(state.display).map((key) => {
      if (key !== keep) state.display[key] = 'none'
    })
    this.setState(state)
  }
  componentDidMount() {
    window.addEventListener('click', this._closeDropdowns.bind(this), false)
  }
  componentWillUnmount() {
    window.removeEventListener('click', this._closeDropdowns, false)
  }
  render () {
    return (
      <ul className="nav navbar-nav navbar-right">
        <li className="dropdown" onClick={this.handleClick.bind(this)}>
          <a data-target="prospective-students" className="dropdown-toggle disabled" >
            Prospective Students <b className="caret"></b>
          </a>
          <ul  className="dropdown-menu" style={{display: this.state.display['prospective-students']}}>
            <li><a href="/employment-data/">Employment Data</a></li>
            <li><a href="/how-to-apply/">How to Apply</a></li>
            <li><a href="/financing-and-scholarships/">Financing &amp; Scholarships</a></li>
            <li><a href="/get-a-job-in-tech/">Career Transition Services</a></li>
            <li><a href="/tutoring/">Tutoring Services</a></li>
          </ul>
        </li>
        <li className="dropdown" onClick={this.handleClick.bind(this)}>
          <a data-target="curriculum" className="dropdown-toggle disabled" >
            Curriculum <b className="caret"></b>
          </a>
          <ul className="dropdown-menu" style={{display: this.state.display['curriculum']}}>
            <li><a href="/learn-to-code/"><strong>Software Development</strong></a></li>
            <li><a href="/courses/code-100/">100: Beginner</a></li>
            <li><a href="/courses/code-201/foundations-of-software-development/">200: Foundations</a></li>
            <li><a href="/courses/code-301/intermediate-software-development/">300: Intermediate</a></li>
            <li><a href="/courses/code-400/">400: Advanced</a></li>
            <li><a href="/courses/code-500/">500: Continuing Education</a></li>
            <li className="divider"></li>
            <li><a href="/learn-cybersecurity/"><strong>Ops and Cybersecurity</strong></a></li>
            <li><a href="/courses/ops-100/">100: Beginner</a></li>
            <li><a href="/courses/ops-201/foundations-of-computer-operations/">200: Foundations</a></li>
            <li><a href="/courses/ops-301/networking-and-systems-administration/">300: Intermediate</a></li>
            <li><a href="/courses/ops-400/">400: Advanced</a></li>
            <li className="divider"></li>
            <li><a href="/learn-web3/"><strong>Web3</strong></a></li>
            <li><a href="/courses/web3-101/explore-cryptocurrencies-and-web3-careers/">100: Beginner</a></li>
          </ul>
        </li>
        <li className="dropdown" onClick={this.handleClick.bind(this)}>
          <a
            data-target="partnerships"
            className="dropdown-toggle disabled"
          >
            Partnerships <b className="caret"></b>
          </a>
          <ul className="dropdown-menu" style={{display: this.state.display['partnerships']}}>
            <li><a href="/powered-by-code-fellows/">Curriculum Licensing</a></li>
            <li><a href="/employer-partnerships/">Employer Services</a></li>
          </ul>
        </li>
        <li><a href="/course-calendar/">Course Calendar</a></li>
        <li><a href="/events-calendar/">Events</a></li>
        <li><a href="/blog/category/testimonials/">Testimonials</a></li>
        <li><a href="/faq/">FAQ</a></li>
        <li>
          <a
            className="btn btn-primary navbar-btn apply_button"
            style={{ paddingTop: '0.5em', paddingBottom: '0.5em' }}
            href="https://learn.codefellows.org/apply-now?utm_audience=students&utm_promo_code=not_applicable&utm_sequence_type=not_applicable&utm_partner=0016100000M954d&utm_source=header&utm_medium=website&utm_content=header&utm_campaign=coding_for_beginners&utm_term=not_applicable&utm_campaign_id=not_applicable&utm_ad_id=not_applicable&utm_adset_id=not_applicable&utm_adset_name=not_applicable&utm_placement=not_applicable&utm_start=not_applicable&utm_cost=organic"
          >
            Apply
          </a>
        </li>
      </ul>
    )
  }
}
export default HeaderNavbar



// WEBPACK FOOTER //
// ./src/components/header-navbar/index.js